// @ts-nocheck
import { Plugin } from '/usr/src/app/apps/web-app/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','locale',],
});

export { plugin };
